module.exports = __webpack_public_path__ + "assets/ae854a5e2718db1e83e41959c66c32bb.png";